__turbopack_context__.v({
  "accent": "SizeableText-module__Lc8Ghq__accent",
  "error": "SizeableText-module__Lc8Ghq__error",
  "fontStyle-italic": "SizeableText-module__Lc8Ghq__fontStyle-italic",
  "fontStyle-normal": "SizeableText-module__Lc8Ghq__fontStyle-normal",
  "fontStyle-oblique": "SizeableText-module__Lc8Ghq__fontStyle-oblique",
  "fontWeight-light": "SizeableText-module__Lc8Ghq__fontWeight-light",
  "fontWeight-medium": "SizeableText-module__Lc8Ghq__fontWeight-medium",
  "fontWeight-strong": "SizeableText-module__Lc8Ghq__fontWeight-strong",
  "fontWeight-xstrong": "SizeableText-module__Lc8Ghq__fontWeight-xstrong",
  "info": "SizeableText-module__Lc8Ghq__info",
  "large": "SizeableText-module__Lc8Ghq__large",
  "medium": "SizeableText-module__Lc8Ghq__medium",
  "primary": "SizeableText-module__Lc8Ghq__primary",
  "secondary": "SizeableText-module__Lc8Ghq__secondary",
  "sizeableText": "SizeableText-module__Lc8Ghq__sizeableText",
  "small": "SizeableText-module__Lc8Ghq__small",
  "success": "SizeableText-module__Lc8Ghq__success",
  "textTransform-capitalize": "SizeableText-module__Lc8Ghq__textTransform-capitalize",
  "textTransform-lowercase": "SizeableText-module__Lc8Ghq__textTransform-lowercase",
  "textTransform-none": "SizeableText-module__Lc8Ghq__textTransform-none",
  "textTransform-uppercase": "SizeableText-module__Lc8Ghq__textTransform-uppercase",
  "warning": "SizeableText-module__Lc8Ghq__warning",
  "white": "SizeableText-module__Lc8Ghq__white",
  "xlarge": "SizeableText-module__Lc8Ghq__xlarge",
  "xsmall": "SizeableText-module__Lc8Ghq__xsmall",
});
